import React from 'react';
import PropertiesProvider from "./properties";
import FilterProvider from "./filters";
import UserProvider from "./user";
import QuestionsProvider from "./questions";
import PostsProvider from "./posts_provider";
import AgenciesProvider from './agencies_provider';


export default function BaseProviders({children}) {
    return (
        <UserProvider>
            <FilterProvider>
                <PropertiesProvider>
                    <QuestionsProvider>
                        <PostsProvider>
                            <AgenciesProvider>
                                {children}
                            </AgenciesProvider>
                        </PostsProvider>
                    </QuestionsProvider>
                </PropertiesProvider>
            </FilterProvider>
        </UserProvider>
    )
}
